import {
    call, put, takeLatest,
} from 'redux-saga/effects'

import { getPayrollPeriods } from '../../helpers/api-ts/payrollPeriod'
import { PayrollPeriod } from '../../models'
import {
    APP_GET_PAYROLL_PERIODS_FAILURE,
    APP_GET_PAYROLL_PERIODS_REQUEST,
    APP_GET_PAYROLL_PERIODS_SUCCESS,
    APP_SAGA_GET_PAYROLL_PERIODS,
} from '../actionTypes'


export function* fetchPayrollPeriods(): any {
    yield put({ type: APP_GET_PAYROLL_PERIODS_REQUEST })

    try {
        const payrollPeriods = yield call(() => getPayrollPeriods())

        const sortedPayrollPeriods = payrollPeriods.sort(
            (payrollPeriodA: PayrollPeriod, payrollPeriodB: PayrollPeriod) => payrollPeriodA.year - payrollPeriodB.year
                || payrollPeriodA.periodNumber - payrollPeriodB.periodNumber,
        )

        yield put({
            type: APP_GET_PAYROLL_PERIODS_SUCCESS,
            payrollPeriods: sortedPayrollPeriods,
        })
    } catch (_error) {
        yield put({ type: APP_GET_PAYROLL_PERIODS_FAILURE })
    }
}

export default function* appWatcher() {
    yield takeLatest(APP_SAGA_GET_PAYROLL_PERIODS, fetchPayrollPeriods)
}
